import { render, staticRenderFns } from "./VolunteerProfileEditAudience.vue?vue&type=template&id=74da5bfa&scoped=true"
import script from "./VolunteerProfileEditAudience.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileEditAudience.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileEditAudience.vue?vue&type=style&index=0&id=74da5bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da5bfa",
  null
  
)

export default component.exports